import i18n from '@signavio/i18n';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const dynatrace = window.dtrum;
const ErrorDetails = ({
  debug,
  children
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx("p", {
    children: i18n('An error prevents this part of the application from working correctly.')
  }), /*#__PURE__*/_jsx("p", {
    children: i18n('We apologize for the inconvenience.')
  }), debug && /*#__PURE__*/_jsxs(_Fragment, {
    children: [" ", children, " "]
  }), dynatrace && /*#__PURE__*/_jsx("p", {
    children: i18n('If this error keeps occurring, please email Customer Support at [support@signavio.com](mailto:support@signavio.com). ' + 'Describe what you were doing when the error occurred to help us fix the issue.', {
      markdown: true
    })
  })]
});
export default ErrorDetails;